import { queryParams, type RouteQueryOptions, type RouteDefinition, type RouteFormDefinition } from './../../wayfinder'
import webhooksSpecification from './webhooks-specification'
import listings from './listings'
import classifieds from './classifieds'
import categories from './categories'
import listingCategories from './listing-categories'
import newsletter from './newsletter'
import contactInquiries from './contact-inquiries'
import phoneVerifications from './phone-verifications'
import favorites from './favorites'
import alerts from './alerts'
import reviews from './reviews'
import banners from './banners'
import workspaces from './workspaces'
import users from './users'
import optionals from './optionals'
import locations from './locations'
/**
* @see routes/web.php:240
* @route '/dashboard'
*/
export const home = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: home.url(options),
    method: 'get',
})

home.definition = {
    methods: ["get","head"],
    url: '/dashboard',
} satisfies RouteDefinition<["get","head"]>

/**
* @see routes/web.php:240
* @route '/dashboard'
*/
home.url = (options?: RouteQueryOptions) => {
    return home.definition.url + queryParams(options)
}

/**
* @see routes/web.php:240
* @route '/dashboard'
*/
home.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: home.url(options),
    method: 'get',
})

/**
* @see routes/web.php:240
* @route '/dashboard'
*/
home.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: home.url(options),
    method: 'head',
})

/**
* @see routes/web.php:240
* @route '/dashboard'
*/
const homeForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: home.url(options),
    method: 'get',
})

/**
* @see routes/web.php:240
* @route '/dashboard'
*/
homeForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: home.url(options),
    method: 'get',
})

/**
* @see routes/web.php:240
* @route '/dashboard'
*/
homeForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: home.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

home.form = homeForm

/**
* @see \App\Http\Controllers\AccountUpgradeController::upgradeToSponsor
* @see app/Http/Controllers/AccountUpgradeController.php:13
* @route '/dashboard/upgrade-to-sponsor'
*/
export const upgradeToSponsor = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: upgradeToSponsor.url(options),
    method: 'post',
})

upgradeToSponsor.definition = {
    methods: ["post"],
    url: '/dashboard/upgrade-to-sponsor',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\AccountUpgradeController::upgradeToSponsor
* @see app/Http/Controllers/AccountUpgradeController.php:13
* @route '/dashboard/upgrade-to-sponsor'
*/
upgradeToSponsor.url = (options?: RouteQueryOptions) => {
    return upgradeToSponsor.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\AccountUpgradeController::upgradeToSponsor
* @see app/Http/Controllers/AccountUpgradeController.php:13
* @route '/dashboard/upgrade-to-sponsor'
*/
upgradeToSponsor.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: upgradeToSponsor.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\AccountUpgradeController::upgradeToSponsor
* @see app/Http/Controllers/AccountUpgradeController.php:13
* @route '/dashboard/upgrade-to-sponsor'
*/
const upgradeToSponsorForm = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: upgradeToSponsor.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\AccountUpgradeController::upgradeToSponsor
* @see app/Http/Controllers/AccountUpgradeController.php:13
* @route '/dashboard/upgrade-to-sponsor'
*/
upgradeToSponsorForm.post = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: upgradeToSponsor.url(options),
    method: 'post',
})

upgradeToSponsor.form = upgradeToSponsorForm

const dashboard = {
    home: Object.assign(home, home),
    webhooksSpecification: Object.assign(webhooksSpecification, webhooksSpecification),
    upgradeToSponsor: Object.assign(upgradeToSponsor, upgradeToSponsor),
    listings: Object.assign(listings, listings),
    classifieds: Object.assign(classifieds, classifieds),
    categories: Object.assign(categories, categories),
    listingCategories: Object.assign(listingCategories, listingCategories),
    newsletter: Object.assign(newsletter, newsletter),
    contactInquiries: Object.assign(contactInquiries, contactInquiries),
    phoneVerifications: Object.assign(phoneVerifications, phoneVerifications),
    favorites: Object.assign(favorites, favorites),
    alerts: Object.assign(alerts, alerts),
    reviews: Object.assign(reviews, reviews),
    banners: Object.assign(banners, banners),
    workspaces: Object.assign(workspaces, workspaces),
    users: Object.assign(users, users),
    optionals: Object.assign(optionals, optionals),
    locations: Object.assign(locations, locations),
}

export default dashboard